import { formatInteger, formatUnits, getCompactDollars, getDecimalNumber } from "../../../agent-production/helpers/dataFormatters";
import { terms as mdt } from "..";
import { marketDynamicsTerms as terms, marketDynamicsTimePeriods as mdtp } from "../../../constants";
import { cardFields } from ".";

export const cardSettings = {
    gridClass: 'grid-3',
    cards: [
        {
            formatter: getDecimalNumber,
            chartDataFormatter: getDecimalNumber,
            keyField: cardFields.ucMsi,
            labelUnitType: mdt.months,
            title: mdt.monthlySupplyOfInventory,
            unitType: mdt.months,
            timePeriods: [mdtp[terms.years1Monthly], mdtp[terms.years2Monthly]],
        },
        {
            formatter: formatInteger,
            chartDataFormatter: formatInteger,
            keyField: cardFields.ucAvgDom,
            labelUnitType: mdt.days,
            title: mdt.avgDom,
            unitType: mdt.days,
            timePeriods: [mdtp[terms.months6Weekly], mdtp[terms.years3Quarterly]],
        },
        {
            formatter: getCompactDollars,
            chartFormatter: getCompactDollars,
            keyField: cardFields.forSaleVolume,
            title: mdt.totalInventoryVolume,
        },
        {
            formatter: formatUnits,
            chartFormatter: formatUnits,
            keyField: cardFields.forSaleUnits,
            title: mdt.totalInventoryUnit,
            labelUnitType: mdt.units,
            chartUnitType: '',
        },
    ],
};
